import React, { useMemo } from 'react';
import { ParticipantAccountReportIcon } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core';

import { useFavoriteReportHandler } from '../../hooks';
import { ReportTypeKeys } from '../../report.types';
import ReportCardBase, { ReportCardBaseProps } from '../ReportCardBase';

import { useParticipantActivityReportCardQuery } from './queries';

interface Props extends ReportCardBaseProps {}
const TEST_ID = 'participant-activity-report-card';
const ParticipantActivityReportCard: React.FC<Props> = ({ isFavoriteMode }) => {
  const {
    data: { activeCount, canceledCount },
    isLoading,
  } = useParticipantActivityReportCardQuery();
  const {
    observingOrganization: { type },
  } = useCurrentOrganization();

  const isSystem = useMemo(() => type === OrganizationTypes.system, [type]);
  const childrenNode = useMemo(() => {
    if (!isSystem) {
      return (
        <ReportCardBase.DescriptionBase
          isLoading={isLoading}
          testId={TEST_ID}
          title="Current plan year counts (all accounts)"
          items={[
            {
              label: 'Active',
              value: `${activeCount || 0}`,
            },
            {
              label: 'Canceled',
              value: `${canceledCount || 0}`,
            },
          ]}
        />
      );
    }
    return null;
  }, [activeCount, canceledCount, isLoading, isSystem]);

  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.ParticipantActivity);

  return (
    <ReportCardBase
      // isUpdated
      isWideMode={isFavoriteMode}
      url={ROUTES.PARTICIPANT_ACTIVITY_REPORT}
      isFavorite={isFavorite}
      testId={TEST_ID}
      onChangeFavorite={handleToggleReportKey}
      icon={
        <ParticipantAccountReportIcon
          size={isFavoriteMode ? '50px' : '40px'}
          color={isFavoriteMode ? 'iconAccent' : 'iconDisabled'}
        />
      }
      title="Participant Account Activity"
      description="View participant account activity,
including claims, contributions, fees,
balances, and enrollment details"
    >
      {childrenNode}
    </ReportCardBase>
  );
};
export default ParticipantActivityReportCard;
